import { KatBreadcrumb, KatBreadcrumbItem } from '@amzn/katal-react';
import React, { useContext } from 'react';
import { BreadCrumbConstants } from 'src/constants/ProjectConstants';
import {
  CREATE_CASE_PAGE_ROUTE,
  LIST_CASE_PAGE_ROUTE,
  CASE_DETAILS_PAGE_ROUTE,
  FORMATTED_CASE_DETAILS_ROUTE,
  ANONYMOUS_CREATE_CASE_PAGE_ROUTE,
  HOME_ROUTE,
} from 'src/constants/UrlConstants';
import styled from 'styled-components';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

export const BreadcrumbContainer = styled.div`
  padding: 5px 20px;
`;

interface IBreadcrumbProps {
  page: string;
  id?: string;
}

export function Breadcrumb({ page, id }: IBreadcrumbProps) {
  const { menuBundle } = useContext(TranslationContext);
  const breadcrumbConfig = {
    [CREATE_CASE_PAGE_ROUTE]: [
      {
        label: menuBundle.getMessage(BreadCrumbConstants.HOME),
        href: `#${LIST_CASE_PAGE_ROUTE}`,
      },
      {
        label: menuBundle.getMessage(BreadCrumbConstants.CREATE_CASE),
        href: `#${CREATE_CASE_PAGE_ROUTE}`,
      },
    ],
    [ANONYMOUS_CREATE_CASE_PAGE_ROUTE]: [
      {
        label: menuBundle.getMessage(BreadCrumbConstants.HOME),
        href: `#${HOME_ROUTE}`,
      },
      {
        label: menuBundle.getMessage(BreadCrumbConstants.CREATE_CASE),
        href: `#${ANONYMOUS_CREATE_CASE_PAGE_ROUTE}`,
      },
    ],
    [LIST_CASE_PAGE_ROUTE]: [
      {
        label: menuBundle.getMessage(BreadCrumbConstants.HOME),
        href: `#${LIST_CASE_PAGE_ROUTE}`,
      },
    ],
    [CASE_DETAILS_PAGE_ROUTE]: [
      {
        label: menuBundle.getMessage(BreadCrumbConstants.HOME),
        href: `#${LIST_CASE_PAGE_ROUTE}`,
      },
      {
        label: `${menuBundle.getMessage(BreadCrumbConstants.VIEW_CASE)}: ${id}`,
        href: `#${FORMATTED_CASE_DETAILS_ROUTE(id!)}`,
      },
    ],
  };

  const getBreadcrumbsLink = () => {
    return breadcrumbConfig[page].map((breadcrumb) => {
      return (
        <KatBreadcrumbItem
          key={breadcrumb.label}
          label={breadcrumb.label}
          href={breadcrumb.href}
        />
      );
    });
  };

  return (
    <BreadcrumbContainer>
      <KatBreadcrumb>{getBreadcrumbsLink()}</KatBreadcrumb>
    </BreadcrumbContainer>
  );
}
